// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"AccountInfoHeader_titleContainer__3C9jN","title":"AccountInfoHeader_title__35Hr-","dateRange":"AccountInfoHeader_dateRange__2rOFw"};